
import React, { useState, forwardRef, useRef } from 'react';
import {
    DialogContent, DialogTitle, Dialog, Paper, TextField, Box, Grid, Typography, TableCell, TableContainer,
    Table, TableHead, Button, IconButton, TableRow, TableBody, Accordion, AccordionDetails,
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
// import PurchaseEntryPrint from './PurchaseEntryPrint';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import styles from '.././../../styles.module.css';
import PurchaseOrderAdd from './PurchaseOrderAdd';
import PurchaseOrderPrint from './PurchaseOrderPrint';
import RemarksSection from '../../reusableComponent/RemarksSection';

const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value, printSetupDetails } = props;
    return (
        <div className="print-source" ref={ref}>
            <PurchaseOrderPrint orderPrint={value} printSetupDetails={printSetupDetails} />
        </div>
    );
});
const ComponentToPrintOrderWrapper = ({ orderPrint, printSetupDetails }) => {

    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <Icon icon="flat-color-icons:print" width="20" height="20" />}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={orderPrint} printSetupDetails={printSetupDetails} />
            </div>
        </div>
    );
};

const PurchaseOrderDetails = (props) => {
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const navigate = useNavigate()

    const detailsView = props.details;
    const termsList = props.termsList;
    const termsDetails = detailsView.PO_terms && JSON.parse(detailsView.PO_terms);
    const printSetupDetails = props.printSetupDetails;


    const [open, setOpen] = useState(false)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClickOpenPopup = (info) => {
        // setInfo(info);
        setOpen(true);
    };

    const navigateToAddEdit = (row) => {
        const state = {
            row,
            // invoiceSettingList,
            termsList,
        };
        navigate('/purchase/add-purchase-order', { state });
    };
    return (
        <>
            <Paper className='mainContainer' sx={{ boxShadow: 'none' }}>
                <Box>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item md={10}>
                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Supplier Name</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.supplierName == null ? '-' : detailsView.CNS_Name}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Purchase Order No</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.purchaseNo}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>PO. Date </Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{dateConversion(detailsView.purchaseDate)}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Quotation No </Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.quotationNo == '' ? '-' : detailsView.quotationNo}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Quotation Date</Typography>
                                </Grid>
                                <Grid item xs={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.quotationNo == '' ? '-' : dateConversion(detailsView.quotationDate)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={2}>
                            <Box >
                                <Grid container spacing={0} >
                                    <Grid item md={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                        <Box sx={{ marginBottom: '6px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'right', }}>
                                                <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} onClick={() => navigateToAddEdit(detailsView)} />
                                            </Box>
                                            < Box >
                                                <Icon icon="clarity:email-line" width="19" height="19" color="red" style={{}} />
                                            </Box>
                                            < Box>
                                                <ComponentToPrintOrderWrapper key={detailsView._id} orderPrint={detailsView} printSetupDetails={printSetupDetails} />
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 140 }}>
                    <Table sx={{ minWidth: 700 }} size='small' stickyHeader>
                        <TableHead >
                            <StyledTableRow>
                                <StyledTableCell align="left" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>
                                    Item Description
                                </StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>HSN Code</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Quantity</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Unit</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Rate</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>GST %</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Amount</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {JSON.parse(detailsView && detailsView.childRows).map((row, index) => (
                                <>
                                    <StyledTableRow key={row.id} >
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>  {row.itemName + ' (' + row.itemCode + ')'}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.hsnCode}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.quantity}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.unit}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.rate}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.gst} %</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{parseFloat(row.amount).toFixed(2)}</StyledTableCell>
                                    </StyledTableRow>
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box style={{ padding: '2px' }}>
                    <Grid container spacing={0} sx={{ mt: 2 }}>
                        <Grid item xs={8}>
                    
                            <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold', paddingBottom: '10px' }}>Terms & Conditions</Typography>
                    
                            {termsDetails.map((row, index) => {
                                if (row.trueFalse) {
                                    const trueRows = termsDetails.filter((r) => r.trueFalse);
                                    const trueRowIndex = trueRows.indexOf(row);
                                    return (
                                        <Grid container spacing={0} sx={{ mt: 0 }} key={index}>
                                            <Grid item xs={12}>
                                                <Box style={{ display: 'flex' }}>
                                                    <Typography className={`${styles.erp_lable}`} style={{ paddingRight: '10px', }}>{trueRowIndex + 1}. </Typography>
                                                    <Typography className={`${styles.erp_lable}`} style={{ paddingBottom: '4px' }}> {row.termsAndConditions}</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    );
                                }
                                return null;
                            })}
                            {/* {(detailsView.remark == '-' || detailsView.remark == '0' ||detailsView.remark == '' || detailsView.remark == null || detailsView.remark == undefined) ?
                                <></>
                                :
                                < Typography className={`${styles.detail_lable}`} > <span style={{ fontWeight: 'bold', paddingTop: '10px' }}>Remarks: </span> {detailsView.remark}</Typography>
                            } */}
                            <RemarksSection remark={detailsView.remark} />
                        </Grid>
                        <Grid item xs={4} >
                            <Grid container spacing={0} sx={{ mt: 0, }} >
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>Basic Total </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', }}>
                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(detailsView.basicTotal).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>GST Total </Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}> {parseFloat(detailsView.gstTotal).toFixed(2)}</Typography>
                                </Grid>
                                <Grid item xs={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}> Total</Typography>
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', }}>
                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(detailsView.total).toFixed(2)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Paper >
            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        height: "95%"
                    }
                }}
                onClose={handleClose}
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    Update Purchase ORDER
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <PurchaseOrderAdd handleCloseDialog={handleClose} details={detailsView} />
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}
export default PurchaseOrderDetails;